module.exports = __webpack_public_path__ + "static/media/toolbar-lecture.e0ff80ea.svg";